import React from 'react';
import { RegularText, Row } from 'src/components';
import { fontSizes, pixelScaler } from 'src/themes/Metrics';

interface Props {
  label: string;
  value: string | React.ReactElement;
  fontWeight?: any;
  fontWeightLabel?: any;
  fontWeightValue?: any;
  fontSize?: keyof typeof fontSizes | number;
  fontSizeLabel?: keyof typeof fontSizes | number;
  fontSizeValue?: keyof typeof fontSizes | number;
  color?: any;
}

export const LabelValueRow = ({
  fontSize,
  label,
  value,
  fontWeight,
  fontWeightLabel,
  fontWeightValue,
  fontSizeLabel,
  fontSizeValue,
  color,
}: Props) => {
  return (
    <Row height={pixelScaler(25)} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
      <RegularText fontWeight={fontWeightLabel || fontWeight} fontSize={fontSizeLabel || fontSize} textLang={label} />
      {typeof value === 'string' ? (
        <RegularText color={color} fontWeight={fontWeightValue || fontWeight} fontSize={fontSizeValue || fontSize}>
          {value}
        </RegularText>
      ) : (
        value
      )}
    </Row>
  );
};
